import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CountriesComponent }           from './countries.component';
import { CountriesService }             from './countries.service';
import { CountryTypesModel }            from '../sessions/models/session.country-types';
import { ImportColumnModel }            from '../imports/typings/imports.column';
import { ImportTransformFunctionModel } from '../imports/typings/imports.transform-function';

export const CountriesStates : Array<NgHybridStateDeclaration> = [
  {
    component: CountriesComponent,
    name     : 'app.countries',
    resolve  : [
      {
        deps     : [ CountriesService ],
        resolveFn: ( countriesService : CountriesService ) : ng.IPromise<Array<CountryTypesModel>> => countriesService.get(),
        token    : 'countries'
      },
      {
        deps     : [ CountriesService ],
        resolveFn: ( countriesService : CountriesService ) : ng.IPromise<Array<ImportColumnModel>> => countriesService.getStateTypeColumns(),
        token    : 'ourColumns'
      },
      {
        deps     : [ CountriesService ],
        resolveFn: ( countriesService : CountriesService ) : ng.IPromise<Array<ImportTransformFunctionModel>> => countriesService.getStateTypeTransformFunctions(),
        token    : 'transformFunctions'
      }
    ],
    url: '/countries'
  }
];
